import { createSelector } from 'reselect'
import { NAME } from './constants'

export const getMessages = createSelector(
  (state) => state[NAME],
  (employeeMessages) => employeeMessages.messageList
)

export const getMessage = createSelector(
  (state) => state[NAME],
  (employeeMessages) => employeeMessages.message
)

export const getIsListView = createSelector(
  (state) => state[NAME],
  (employeeMessages) => employeeMessages.isListView
)
